var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganize(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v100H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 50c0 24.853-20.147 45-45 45S15 74.853 15 50 35.147 5 60 5s45 20.147 45 45z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -8,
    y: 5,
    width: 113,
    height: 90
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.123 5C84.909 5 105 25.147 105 50S84.909 95 60.123 95H-7.799V5h67.922z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.816 84.701h90.973c1.358 0 2.459-.985 2.453-2.2V18.13a2.443 2.443 0 0 0-2.443-2.443h-91a2.443 2.443 0 0 0-2.443 2.443V82.5c0 1.215 1.1 2.2 2.46 2.2z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.357 31.567h95.886V17.805c0-1.17-1.168-2.117-2.609-2.117H14.966c-1.44 0-2.61.948-2.61 2.117v13.762z",
    fill: "#399C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.792 31.567H12.356v36.645h104.436V31.567zM58.043 77.983H21.635c-1.08 0-1.95-.819-1.95-1.832 0-1.014.87-1.833 1.95-1.833h36.408c1.08 0 1.95.819 1.95 1.833 0 1.013-.87 1.832-1.95 1.832z",
    fill: "#E8E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.876 51.721H22.861c-1.42 0-2.566-1.227-2.566-2.748 0-1.52 1.146-2.748 2.566-2.748h26.015c1.42 0 2.567 1.227 2.567 2.748 0 1.52-1.147 2.748-2.567 2.748z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.862 25.46H21.386c-.941 0-1.701-.682-1.701-1.527 0-.845.76-1.527 1.7-1.527h12.477c.942 0 1.702.682 1.702 1.527 0 .845-.76 1.527-1.702 1.527zM54.693 25.46H42.697c-.906 0-1.637-.682-1.637-1.527 0-.845.731-1.527 1.636-1.527h11.997c.906 0 1.636.682 1.636 1.527 0 .845-.73 1.527-1.636 1.527zM76.003 25.46H63.527c-.942 0-1.701-.682-1.701-1.527 0-.845.76-1.527 1.701-1.527h12.476c.942 0 1.702.682 1.702 1.527 0 .845-.76 1.527-1.702 1.527z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.424 51.26H63.047v5.934c0 4.694 1.555 8.535 4.497 11.016h17.383c.01-.005.015.005.026 0 2.926-2.465 4.477-6.339 4.477-11.021l-.006-5.93z",
    fill: "#F0F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.66 56.73a24.957 24.957 0 0 0 1.65 6.972l1.764 4.508h9.434l1.765-4.503a24.873 24.873 0 0 0 1.649-6.977H79.66zM95.34 48.795l-2.838-11.732h-9.424l-2.837 11.738a24.002 24.002 0 0 0-.445 2.35h-.006a25.855 25.855 0 0 0-.21 4.627c.016.367.048.585.08.951H95.92c.032-.366.063-.584.079-.95.105-2.334-.094-4.689-.66-6.984z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.314 63.702a24.792 24.792 0 0 1-1.649-6.967H63.047v.46c0 4.693 1.555 8.534 4.497 11.015h17.383c.01-.005.015.005.026 0h-1.88l-1.759-4.508z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43 57.188v-.459h-9.77a24.875 24.875 0 0 0 1.65 6.967l1.764 4.508h1.88c2.926-2.464 4.476-6.333 4.476-11.016z",
    fill: "#B6BABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.58 55.653c-.067-1.497 0-2.901.216-4.393h-16.75V56.729H79.66c-.032-.36-.058-.715-.08-1.076z",
    fill: "#D2D5D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.58 55.653c.016.355.041.723.073 1.078l9.772.003-.001-1.037V51.26H79.79a23.31 23.31 0 0 0-.21 4.393z",
    fill: "#B6BABF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v100H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 2.356,
    y: 7.688,
    width: 115.886,
    height: 89.013,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganize);
export default __webpack_public_path__ + "static/media/organize.a4a00b580616e82bfa6b01055b421913.svg";
export { ForwardRef as ReactComponent };